import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LanguageWrapper: React.FC = () => {
	const { i18n } = useTranslation();
	const location = useLocation();
	const lang = location.pathname.split("/")[1];
	useEffect(() => {
		if (["en"].includes(lang)) {
			i18n.changeLanguage('en').then();
		} else {
			i18n.changeLanguage('he').then();
		}
	}, [lang, i18n]);

	return <Outlet />;
}

export default LanguageWrapper;
